import AuthClass from './../../../js/classes/Auth.js'

import './styles.scss'

//SIGN IN
const signInForm = document.querySelector('.happy-auth__signin')

if (signInForm) {
    signInForm.addEventListener('submit', (e) => {
        e.preventDefault()

        const inputLogin = document.querySelector('#signin-login'),
        inputPassword = document.querySelector('#signin-password'),
        inputRemember = document.querySelector('#signin-remember'),
        buttonSignIn = document.querySelector('.button_signin'),
        params = {
            LOGIN : inputLogin.value.trim(),
            PASSWORD : inputPassword.value.trim(),
            REMEMBER : inputRemember.checked,
        }

        inputLogin.classList.remove('form__input_error')
        inputPassword.classList.remove('form__input_error')

        const text = buttonSignIn.textContent
        buttonSignIn.textContent = 'Авторизация..'
        buttonSignIn.setAttribute('disabled', 'disabled')

        AuthClass.signin((err, res) => {
            if (res === true) {
                document.location.reload()
            } else {
                inputLogin.classList.add('form__input_error')
                inputPassword.classList.add('form__input_error')

                buttonSignIn.textContent = text
                buttonSignIn.removeAttribute('disabled')
            }
        }, params)

        return false
    })
}

//SIGN UP
const signUpForm = document.querySelector('.happy-auth__signup')

if (signUpForm) {
    const imageCaptcha = document.querySelector('#signup-captcha-image'),
    inputCaptchaSID = document.querySelector('#signup-captcha-sid'),
    reloadCaptcha = () => {
        AuthClass.getCaptchaSID((err, captchaSID) => {
            

            if (typeof captchaSID === 'string') {
                imageCaptcha.setAttribute('src', `/bitrix/tools/captcha.php?captcha_sid=${ captchaSID }`)
                inputCaptchaSID.value = captchaSID
            } else {
                console.log(err)
            }
        })
    }

    imageCaptcha.addEventListener('click', () => {
        reloadCaptcha()
    })
    

    signUpForm.addEventListener('submit', (e) => {
        e.preventDefault()

        const inputLastName = document.querySelector('#signup-last-name'),
        inputName = document.querySelector('#signup-name'),
        inputEmail = document.querySelector('#signup-email'),
        inputPassword = document.querySelector('#signup-password'),
        inputConfirmPassword = document.querySelector('#signup-confirm-password'),
        inputCaptchaWord = document.querySelector('#signup-captcha-word'),
        buttonSignIn = document.querySelector('.button_signup'),
        params = {
            USER_NAME : inputName.value.trim(),
            USER_LAST_NAME : inputLastName.value.trim(),
            USER_PASSWORD : inputPassword.value.trim(),
            USER_CONFIRM_PASSWORD : inputConfirmPassword.value.trim(),
            USER_EMAIL : inputEmail.value.trim(),
            CAPTCHA_WORD : inputCaptchaWord.value.trim(),
            CAPTCHA_SID : inputCaptchaSID.value
        }

        inputLastName.classList.remove('form__input_error')
        inputName.classList.remove('form__input_error')
        inputEmail.classList.remove('form__input_error')
        inputPassword.classList.remove('form__input_error')
        inputConfirmPassword.classList.remove('form__input_error')
        inputCaptchaSID.classList.remove('form__input_error')
        inputCaptchaWord.classList.remove('form__input_error')

        const text = buttonSignIn.textContent
        buttonSignIn.textContent = 'Регистрация..'
        buttonSignIn.setAttribute('disabled', 'disabled')

        AuthClass.signup((err, res) => {
            buttonSignIn.textContent = text
            buttonSignIn.removeAttribute('disabled')


            if (res === true) {
                document.location.reload()
            } else if (err) {
                if (err[0].message.indexOf('Неверное подтверждение пароля.<br>') !== -1) {
                    inputConfirmPassword.classList.add('form__input_error')
                }

                if (err[0].message.indexOf('The CAPTCHA value could not be validated') !== -1) {
                    inputCaptchaWord.classList.add('form__input_error')
                }

                if (
                    err[0].message.indexOf('Неверный email.<br>') !== -1 || 
                    err[0].message.indexOf(`Пользователь с логином "${ inputEmail.value }" уже существует.<br>`) !== -1
                ) {
                    inputEmail.classList.add('form__input_error')
                }

                if (err[0].message.indexOf('Пароль должен  быть не менее 6 символов длиной.<br>') !== -1) {
                    inputPassword.classList.add('form__input_error')
                    inputConfirmPassword.classList.add('form__input_error')
                }
                

                buttonSignIn.textContent = text
                buttonSignIn.removeAttribute('disabled')
            }

            reloadCaptcha()
        }, params)

        return false
    })
}

//FORGOT PASSWORD
const forgotPasswordForm = document.querySelector('.happy-auth__forgot-password')

if (forgotPasswordForm) {
    forgotPasswordForm.addEventListener('submit', (e) => {
        e.preventDefault()

        const emailInput = document.querySelector('#forgot-password-email'),
        buttonForgotPassword = document.querySelector('.button_forgot-password'),
        email = emailInput.value

        const text = buttonForgotPassword.textContent
        buttonForgotPassword.textContent = 'Восстановление пароля..'
        buttonForgotPassword.setAttribute('disabled', 'disabled')

        AuthClass.forgotPassword((err, res) => {
            console.log(err, res)
            
            if (res === true) {
                document.location = '/personal/forgot-password/?check=Y'
            } else {

            }
            
            buttonForgotPassword.textContent = text
            buttonForgotPassword.removeAttribute('disabled')
        }, {
            EMAIL : email
        })

        return false
    })
}

//RESTORE PASSWORD
const restorePasswordForm = document.querySelector('.happy-auth__restore-password')

if (restorePasswordForm) {
    restorePasswordForm.addEventListener('submit', (e) => {
        e.preventDefault()

        const loginInput = document.querySelector('#restore-password-login'),
        checkwordInput = document.querySelector('#restore-password-checkword'),
        newPasswordInput = document.querySelector('#restore-password-new-password'),
        confirmNewPasswordInput = document.querySelector('#restore-password-confirm-new-password'),
        buttonRestorePassword = document.querySelector('.button_restore-password')
        
        const login = loginInput.value,
        checkword = checkwordInput.value,
        newPassword = newPasswordInput.value,
        confirmNewPassword = confirmNewPasswordInput.value


        const text = buttonRestorePassword.textContent
        buttonRestorePassword.textContent = 'Восстановление пароля..'
        buttonRestorePassword.setAttribute('disabled', 'disabled')

        AuthClass.restorePassword((err, res) => {
            console.log(err, res)

            if (res === true) {
                document.location = '/personal/'
            } else {

            }

            buttonRestorePassword.textContent = text
            buttonRestorePassword.removeAttribute('disabled')
        }, {
            LOGIN : login,
            CHECKWORD : checkword,
            NEW_PASSWORD : newPassword,
            CONFIRM_NEW_PASSWORD : confirmNewPassword
        })

        return false
    })
}